import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import MainLayout from "../_components/MainLayout";
import OnboardAttendance from "./OnboardAttendance";

const context = "onboard";
export default class OnboardAttendancePage extends Component {
  constructor() {
    super();
    this.state = {};
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Attendance",
      context: context,
    });
  }

  render() {
    const _this = this;
    const { isMobile } = this.state;

    return (
      <MainLayout context={context} _this={_this}>
        <OnboardAttendance isMobile={isMobile} />
      </MainLayout>
    );
  }
}
